import request from "../utils/request"

export default {
    /**
     * 功能：获取星币充值套餐和支付开关。
     * 参数：无。
     */
    getRechargeConfig() {
        return request({
            url: `/payment?ac=config`,
            method: 'get'
        })
    },

    /**
     * 功能：创建第三方支付充值订单。
     * 参数：data 包含 amount 充值金额和 channel 支付渠道。
     */
    createRecharge(data) {
        return request({
            url: `/payment?ac=create`,
            method: 'post',
            data
        })
    },

    /**
     * 功能：查询充值订单支付状态。
     * 参数：params 包含 orderNo 充值订单号。
     */
    getRechargeStatus(params) {
        return request({
            url: `/payment?ac=status`,
            method: 'get',
            params
        })
    },

    /**
     * 功能：获取当前用户的待支付充值订单。
     * 参数：无。
     */
    getPendingRechargeOrders() {
        return request({
            url: `/payment?ac=pending`,
            method: 'get'
        })
    }
}
